// @flow
import { ImportQueryQuery, ImportQueryMsg, ImportQueryResponse } from '../autogenerated/ZoomBridge';
import AssetUploadJob from './AssetUploadJob';
import Upload from './Upload';
import t from '../i18n/I18n';

const debug = require('../debug/debug')('wc:upload:runImportQuery');

/**
 * Runs the import query given an array of jobs.
 */
export default async function runImportQuery(
  jobs: AssetUploadJob[],
  uniqueKey: any,
  path: string,
  collectionId: ?number,
  fileNames: ?(String[])
): ImportQueryResponse {
  if (!(jobs && jobs.length && !fileNames)) {
    return;
  }
  let uploads: Upload[] = undefined;
  try {
    const query = new ImportQueryQuery();
    const msg = new ImportQueryMsg();
    if (!fileNames) {
      fileNames = [];
      uploads = jobs.map((j) => j.upload);
      debug(`Issuing upload query for ${uploads.length} files`);
      uploads.forEach((u) => {
        u.imported = true;
        fileNames.push(u.name);
      });
    }

    msg.setUniqueKey(uniqueKey);
    msg.setFileNames(fileNames);
    msg.setPath(path);
    if (collectionId) {
      msg.setCollectionId(collectionId);
    } else if (uploads && uploads.length === 1) {
      if (uploads[0].collectionId) {
        msg.setCollectionId(uploads[0].collectionId);
      }
    }

    query.message = msg;
    const res: ImportQueryResponse = await query.run();
    debug('Success. Response: ', res);

    if (uploads)
      uploads.forEach((u) => {
        u.status = 'FINISHED';
      });

    return res;
  } catch (err) {
    debug('error: ', err);
    if (uploads)
      uploads.forEach((u) => {
        u.status = 'ERROR';
        u.errorText = err.errorDetails && err.errorDetails.length > 0 ? err.errorDetails : t('UPLOAD_ERROR');
      });
    throw err;
  }
}

export const runImportQuery2 = function(
  jobs: AssetUploadJob[],
  uniqueKey: any,
  path: string,
  collectionId: ?number,
  fileNames: ?(String[])
) {
  let uploads: Upload[] = undefined;
  return new Promise(async (resolve, reject) => {
    try {
      const query = new ImportQueryQuery();
      const msg = new ImportQueryMsg();
      msg.setUniqueKey(uniqueKey);
      msg.setFileNames(fileNames);
      msg.setPath(path);
      if (collectionId) {
        msg.setCollectionId(collectionId);
      } else if (uploads && uploads.length === 1) {
        if (uploads[0].collectionId) {
          msg.setCollectionId(uploads[0].collectionId);
        }
      }
      query.message = msg;
      const res: ImportQueryResponse = await query.run();
      debug('Success. Response: ', res);

      if (uploads)
        uploads.forEach((u) => {
          u.status = 'FINISHED';
        });

      resolve(res);
    } catch (err) {
      debug('error: ', err);
      if (uploads)
        uploads.forEach((u) => {
          u.status = 'ERROR';
          u.errorText = err.errorDetails && err.errorDetails.length > 0 ? err.errorDetails : t('UPLOAD_ERROR');
        });
      reject(err);
    }
  });
};
